export const useShowJpgImages = () => {
  const isSafari =
    navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
  const isIE = /* @cc_on!@ */ false || 'documentMode' in document;

  return !!(isSafari || isIE);
};
